import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { ImgixClient } from '@belong/common/ImgixClient';
import { Image } from '../Image/Image.js';

const prismicImgixDomain = 'images.prismic.io';
const prismicImgixClient = new ImgixClient({
  domain: prismicImgixDomain
});
const PrismicImageAdapter = /*#__PURE__*/React.forwardRef(function PrismicImageAdapter({
  src,
  ...props
}, ref) {
  if (typeof src !== 'string' || src.length === 0) {
    return null;
  }
  let parsedImageUrl;
  try {
    parsedImageUrl = new URL(src);
  } catch {
    return null;
  }
  // Prismic incorrectly adds "+" symbols when there are spaces on image names.
  const sanitizedImagePath = parsedImageUrl.pathname.replace(/\+/g, ' ');
  return jsx(Image, {
    ...props,
    src: sanitizedImagePath,
    client: prismicImgixClient,
    ref: ref
  });
});

export { PrismicImageAdapter };
